import React from "react";
import { auth } from "../../firebase/firebase.utils";
import { User } from "../../types/User";
import LogoutIcon from "../../assets/logout.png";
import "./user-card.scss";
type UserCardProps = {
  user: User;
  onLogout: () => void;
};
const UserCard: React.FC<UserCardProps> = ({ user, onLogout }) => {
  const logOut = () => {
    auth.signOut();
    onLogout();
  };

  return (
    <div className="user-card-wrapper">
      <div className={"user-image"}>
        <img alt="user" className={"photo"} src={user.photoURL} />
      </div>
      <div className={"user-info"}>
        <div className={"user-name"}>{user.displayName}</div>
        <div className={"user-email"}>{user.email}</div>
      </div>
      <button onClick={logOut}>
        <img alt="logout" src={LogoutIcon} className={"log-out-icon"} />
      </button>
    </div>
  );
};
export default UserCard;
